export default __webpack_public_path__ + "static/IDMC_GRID_2022 Desplazamientos internos en 2021-86a5ee2ef661460d8bb7ee5e010f25fd.jpg";